
<div class="quote-page">
  <section class="quote-section">
    <div class="quote-container">

      <!-- LEFT CONTENT -->
      <div class="quote-content">

        <!-- <span class="quote-badge">
          <i class="bi bi-stars"></i>
          Free Quote
        </span> -->

<h1>
  Build Smarter, Scale Faster
  <span>Grow with MALtech.</span>
</h1>

        <p class="quote-desc">
  Our team will review the details and get in touch with you soon.
</p>

<!-- STATIC SERVICES AND PRODUCTS -->
<div
  class="source-group"
  *ngFor="let group of sources">

  <h3>{{ group.title }}</h3>

  <div class="chips">
    <span
      class="chip"
      *ngFor="let item of group.items">

      <i class="bi bi-check-lg"></i>
      <span>{{ item }}</span>

    </span>
  </div>

</div>

<!-- SERVICES TAGLINE -->
<p class="services-tagline">
  <i class="bi bi-lightbulb me-2"></i>
  Transforming ideas into innovative digital solutions that drive growth.
</p>

        <!-- BENEFITS -->
        <div class="quote-perks">

          <div class="perk-item">
            <span class="perk-icon">
              <i class="bi bi-lightning-charge-fill"></i>
            </span>
            <span>Quick response</span>
          </div>

          <div class="perk-item">
            <span class="perk-icon">
              <i class="bi bi-headset"></i>
            </span>
            <span>Dedicated support</span>
          </div>

          <div class="perk-item">
            <span class="perk-icon">
              <i class="bi bi-shield-lock-fill"></i>
            </span>
            <span>Your data is safe</span>
          </div>

        </div>

      </div>

      <!-- RIGHT FORM CARD -->
      <div class="quote-card">

        <div class="form-header">

          <div class="form-heading-icon">
            <i class="bi bi-send-fill"></i>
          </div>

          <h2>Let’s Talk About Your Project!</h2>

          <p>
            Fill in your details and let's discuss your project.
          </p>

        </div>

        <form
          [formGroup]="form"
          (ngSubmit)="submit()"
          novalidate>

          <!-- FULL NAME -->
          <mat-form-field
            appearance="outline"
            subscriptSizing="dynamic">

            <mat-label>Full Name</mat-label>

            <input
              matInput
              formControlName="full_name"
              autocomplete="name"
              (keydown)="preventAngleBrackets($event)" />

            <i
              matPrefix
              class="bi bi-person quote-prefix-icon">
            </i>

            <mat-error *ngIf="form.get('full_name')?.hasError('required')
                  && form.get('full_name')?.touched">
              Full name is required
            </mat-error>

            <mat-error
              *ngIf="form.get('full_name')?.hasError('pattern')">
              Enter a valid name using letters and spaces
            </mat-error>

          </mat-form-field>

          <!-- BUSINESS EMAIL -->
          <mat-form-field
            appearance="outline"
            subscriptSizing="dynamic">

            <mat-label>Business Email</mat-label>

            <input
              matInput
              type="email"
              formControlName="business_email"
              autocomplete="email"
              (keydown)="preventAngleBrackets($event)" />

            <i
              matPrefix
              class="bi bi-envelope quote-prefix-icon">
            </i>

            <mat-error 
            *ngIf="form.get('business_email')?.hasError('required')
                     && form.get('business_email')?.touched">
              Email is required
            </mat-error>
            
            <mat-error *ngIf="form.get('business_email')?.hasError('email')
                     && form.get('business_email')?.touched">
              Enter a valid email address
            </mat-error>


          </mat-form-field>

<!-- PHONE NUMBER -->
<mat-form-field
  appearance="outline"
  subscriptSizing="dynamic">

  <mat-label>Phone Number</mat-label>

  <input
    matInput
    type="tel"
    formControlName="phone_number"
    autocomplete="tel"
    (keydown)="preventAngleBrackets($event)" />

  <i
    matPrefix
    class="bi bi-telephone quote-prefix-icon">
  </i>  

  <mat-error *ngIf="form.get('phone_number')?.hasError('required')
           && form.get('phone_number')?.touched">
    Phone number is required.
  </mat-error>
  
  <mat-error *ngIf="form.get('phone_number')?.hasError('pattern')
           && form.get('phone_number')?.touched">
    Enter a valid phone number.
  </mat-error>


</mat-form-field>

          <!-- COMPANY NAME -->
          <mat-form-field
            appearance="outline"
            subscriptSizing="dynamic">

            <mat-label>Company Name</mat-label>

            <input
              matInput
              formControlName="company_name"
              autocomplete="organization"
              (keydown)="preventAngleBrackets($event)" />

            <i
              matPrefix
              class="bi bi-building quote-prefix-icon">
            </i>


          </mat-form-field>

          <!-- COUNTRY SEARCH -->
          <mat-form-field
            appearance="outline"
            subscriptSizing="dynamic">

            <mat-label>Country</mat-label>

            <mat-select
              formControlName="country"
              panelClass="quote-panel">

              <mat-option>
                <ngx-mat-select-search
                  [formControl]="countrySearch"
                  placeholderLabel="Search country..."
                  noEntriesFoundLabel="No country found">
                </ngx-mat-select-search>
              </mat-option>

              <mat-option
                *ngFor="let c of filteredCountries"
                [value]="c.name">

                {{ c.name }}

              </mat-option>

            </mat-select>

            <i
              matPrefix
              class="bi bi-globe2 quote-prefix-icon">
            </i>

            <mat-error *ngIf="form.get('country')?.hasError('required')
                     && form.get('country')?.touched">
              Please select a country
            </mat-error>


          </mat-form-field>

          <!-- SERVICE SEARCH -->
          <mat-form-field
            appearance="outline"
            subscriptSizing="dynamic">

            <mat-label>Type of Service</mat-label>

            <mat-select
              formControlName="type_of_service"
              panelClass="quote-panel">

              <mat-option>
                <ngx-mat-select-search
                  [formControl]="serviceSearch"
                  placeholderLabel="Search service..."
                  noEntriesFoundLabel="No service found">
                </ngx-mat-select-search>
              </mat-option>

              <mat-option
                *ngFor="let s of filteredServices"
                [value]="s.service_name">

                {{ s.service_name }}

              </mat-option>

            </mat-select>

            <i
              matPrefix
              class="bi bi-layers quote-prefix-icon">
            </i>

            <mat-error *ngIf="form.get('type_of_service')?.hasError('required')
                     && form.get('type_of_service')?.touched">
              Please select a service
            </mat-error>


          </mat-form-field>

          <!-- SUBMIT BUTTON -->
          <button
            mat-flat-button
            class="submit-btn"
            type="submit"
            [disabled]="isSubmitting">

            <ng-container *ngIf="!isSubmitting">
              <span>Submit</span>
              <!-- <i class="bi bi-arrow-right"></i> -->
            </ng-container>

            <ng-container *ngIf="isSubmitting">
              <span>Submitting...</span>
            </ng-container>

          </button>

          <!-- PRIVACY -->
          <p class="privacy-text">
            <i class="bi bi-shield-check"></i>
            By submitting, you agree to be contacted by MALtech
            regarding your enquiry.
          </p>

        </form>

      </div>

    </div>
  </section>
</div>